// @flow
import React from 'react';

import { descriptorsLibrary } from 'Client/cms/toolkit/descriptors';
import { ResponsiveTabs } from 'Components/frameworks/responsive-tabs/ResponsiveTabs.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import { ICONS } from 'Components/utils/icon/icons';

type TabLineProps = {
  anchor: string,
  color: string,
  header: {
    icon: string,
    title: string,
  },
  isExpanded?: boolean,
};

type Props = {
  lines: Array<{
    props: TabLineProps,
    name: string,
  }>,
  id?: string,
};

export function TabsLine({ id, ...props }: Props) {
  const items = props.lines.map(line => {
    const TabContent = descriptorsLibrary[line.name].component;
    return {
      header: {
        color: line.props.color,
        iconName: line.props.header.icon,
        title: line.props.header.title,
      },
      id: line.props.anchor || null,
      content: [<TabContent {...line.props} key="1" />],
    };
  });

  const initialSelectedItems = props.lines
    .map((line, index) => {
      return line.props.isExpanded ? index : -1;
    })
    .filter(i => i > -1);

  return (
    <SiteContainer className="Line" id={id}>
      <ResponsiveTabs
        areAllCollapsable
        collapseIconName={ICONS.MINUS}
        expandIconName={ICONS.PLUS}
        initialSelectedItems={initialSelectedItems}
        items={items}
      />
    </SiteContainer>
  );
}
